export default $axios => resource => ({
  fetchSupportList() {
    return $axios.get(`${resource}/csproducts/support`)
  },
})
